import React, { useState, useEffect } from "react";
import GroupSelector from "./GroupSelector";
import UserGroupSkill from './UserSkill';
import { useDispatch, useSelector } from "react-redux";
import {
  getUserGroupSkill,
  setSearchByDeptName,
  setSearchByGroupId,
} from "../../../Redux/Actions/user_skill_group_actions";



const Skills = ({ department,userSkillParentCallback,page_action,department_id }) => {
  
  const initialValues = {
    group_id: "",
    skill_id:""
  };
  const dispatch = useDispatch();
  const { userGroups } = useSelector((state) => state.UserGroupMatrix);
  
  const [values, setValues] = useState(initialValues);
  const [GroupArr, setGroupIDValues] = useState(null);
  const [skill, setSkillValues] = useState();
  const [loadPage,setLoadPage] = useState(page_action)
  //console.log(GroupArr);return false;
  const { group_id } = values;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    setLoadPage(page_action)
  };

  useEffect(() => {
    if(group_id) dispatch(getUserGroupSkill(group_id));
  }, [group_id]);
  // useEffect(() => {
  //   setGroupIDValues(userGroups?.data)
  // }, [userGroups?.data]);
 // console.log(GroupArr);
  const handleSearchGroup = () => {
    if (!group_id) {
      dispatch(setSearchByDeptName(department));
      dispatch(setSearchByGroupId(group_id));

    }
    if (department) dispatch(setSearchByDeptName(department));
    if (group_id) dispatch(setSearchByGroupId(group_id));
    setGroupIDValues(userGroups?.data)

  };
  

  return (
    <div
      class="tab-pane"
      id="skills"
      role="tabpanel"
      aria-labelledby="skills-tab"
    >
      <div class="row mb25">
        {loadPage === 'view' ?
        <div class="col-md-4">
          <div class="form-blk mb20">
            <div class="form-label">Department</div>
            <div class="form-input">
              <input
                type="text"
                class="form-control"
                name="departmentName"
                readOnly
                value={department}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        :""}
        <div class="col-md-4 pl07 pr07">
          <GroupSelector handleChange={handleChange}  group_id={group_id} department_id={department_id}/>
        </div>
        <div class="col-md-4 pl07">
          <label class="h49"></label>
          <button onClick={handleSearchGroup} class="btn_5">Search</button>
        </div>
      </div>
      {GroupArr?.map((GI, i) => {
        //console.log(GI.group_id)
        return (
          <UserGroupSkill group_id={GI.group_id} userSkillParentCallback={userSkillParentCallback} btn_action={loadPage} group_name={GI.group_name} key={i}  />
        )
      })}
    </div>
  );
};

export default Skills;
